import { Box, Grid, Typography } from '@mui/material';
import { useState } from 'react';

import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import { usePqrFormEdit } from './hook';
import FormView from '../../../../components/views/formView';
import { PqrFormEditProps } from './props';
import { PqrStatusManagement } from './statusManagement';
import { PqrData } from '../form/data';
import { PqrAttachment } from '../form/attachment';
import { PqrReconsideration } from '../form/reconsideration';
import { PqrProductData } from '../form/productData';
import { PqrStrategicAlly } from '../form/strategicAlly';
import { PqrHeadInfo } from './headInfo';
import { PqrInitialCausality } from './initialCausality';
import { PqrNotificationClient } from './notificationClient';
import { PqrRedirect } from './redirect';
import { PqrInFavorOf } from './inFavorOf';
import { PqrFinalCausality } from './finalCausality';
import { PqrResponseMedium } from './responseMedium';
import { PqrClosing } from './closing';
import { PqrDataSfc } from './dataSfc';
import { Dialog } from '../../../../components/general/dialog/dialog';
import Loading from '../../../../components/general/loadings/loading';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import {
    PQR_DETAIL,
    PQR,
    SAMPLES,
    SAMPLES_DETAIL,
} from '../../../../../routes/paths';
import { PqrHistorical } from '../historical';
import { PqrInitialCausality as PqrInitialCausalityType } from '../../../../../shared/types/modules/pqr';

export const PqrFormEdit = ({ showFormView, isSample }: PqrFormEditProps) => {
    const [showHistorical, setShowHistorical] = useState(false);

    const {
        pqr,
        idAccount,
        loading,
        handleSubmit,
        handleClean,
        setFormikPqrData,
        formikPqrData,
        formikPqrStatusManagement,
        formikPqrInFavorOf,
        formikPqrInitialCausality,
        setFormikPqrDataSfc,
        setFormikPqrInitialCausality,
        setFormikPqrNotificationClient,
        setFormikPqrStatusManagement,
        setFormikPqrReconsideration,
        setFormikPqrProductData,
        setFormikPqrStrategicAlly,
        setAttachments,
        setFormikPqrRedirect,
        setFormikPqrInFavorOf,
        setFormikPqrFinalCausality,
        setFormikPqrResponseMedium,
        setFormikPqrClosing,
        setFormikPqrHeadInfo,
        setInitialCausalityCurrent,
        isClousureStatus,
        isPhysicalReceptionChannel,
        isEmailReceptionChannel,
        isFaxReceptionChannel,
        isSocialMediaReceptionChannel,
        isOpenErrorSFCModal,
        setIsOpenErrorSFCModal,
        responseSmart,
        onIsWorngMovement,
        pqrHistorical,
        statusCode,
        isCausalityFraud,
        setIsCausalityFraud,
        resetInitialCausality,
        onProductChange,
        isOpen,
        handleClose,
        message,
    } = usePqrFormEdit(showHistorical, isSample);

    const showActionButtons = pqr && pqr?.id ? true : false;
    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };
    return (
        <>
            {showFormView && (
                <FormView
                    title={pqr && pqr.id ? 'Editar PQR' : 'Crear PQR'}
                    additionalButtons={
                        <ActionButtonGroup
                            id={pqr?.id || ''}
                            buttonSearch={{
                                show: true,
                                route: isSample ? SAMPLES : PQR,
                            }}
                            buttonView={{
                                show: true,
                                route: isSample ? SAMPLES_DETAIL : PQR_DETAIL,
                            }}
                            buttonLog={{
                                show: showActionButtons,
                            }}
                            onHistoricalShow={toggleHistorical}
                        />
                    }
                >
                    {showHistorical && (
                        <Box sx={{ marginTop: 2 }}>
                            <PqrHistorical
                                historical={pqrHistorical ?? []}
                                showHistorical={true}
                            />
                        </Box>
                    )}
                </FormView>
            )}
            <PqrHeadInfo
                pqr={pqr}
                onChangeFormik={(formik) => setFormikPqrHeadInfo(formik)}
            />
            <PqrData
                data={pqr?.data}
                onChangeFormik={(formik) => setFormikPqrData(formik)}
                onTypeChange={resetInitialCausality}
            />
            <PqrInitialCausality
                data={
                    pqr?.initialCausality ??
                    (pqr?.initialCausalityCurrent as PqrInitialCausalityType)
                }
                onChangeFormik={(formik) =>
                    setFormikPqrInitialCausality(formik)
                }
                typePqr={formikPqrData?.values.type as string}
                isFormikError={
                    Object.keys(formikPqrInitialCausality?.errors || {})
                        .length > 0
                }
                setIsCausalityFraud={setIsCausalityFraud}
                onProductChange={onProductChange}
                setInitialCausalityCurrent={setInitialCausalityCurrent}
            />
            <PqrNotificationClient
                data={pqr?.notificationClients}
                onChangeFormik={(formik) =>
                    setFormikPqrNotificationClient(formik)
                }
                idAccount={pqr?.id || idAccount}
            />
            <PqrProductData
                data={pqr?.productData}
                onChangeFormik={(formik) => setFormikPqrProductData(formik)}
            />
            <PqrStatusManagement
                data={pqr?.statusManagement}
                onChangeFormik={(formik) =>
                    setFormikPqrStatusManagement(formik)
                }
                createdAt={pqr?.created_at}
                status={pqr?.info?.status as string}
                receptionChannel={
                    formikPqrData?.values.receptionChannel as string
                }
                type={formikPqrData?.values.type as string}
                half={formikPqrData?.values.half as string}
                subtypeDp={formikPqrData?.values.subtypeDp as string}
                procedure={formikPqrData?.values.procedure as string}
                isPhysicalReceptionChannel={isPhysicalReceptionChannel}
                isEmailReceptionChannel={isEmailReceptionChannel}
                isFaxReceptionChannel={isFaxReceptionChannel}
                isSocialMediaReceptionChannel={isSocialMediaReceptionChannel}
                onIsWorngMovement={onIsWorngMovement}
            />
            <PqrReconsideration
                data={pqr?.reconsideration}
                onChangeFormik={(formik) => setFormikPqrReconsideration(formik)}
            />
            <PqrStrategicAlly
                data={pqr?.strategicAlly}
                onChangeFormik={(formik) => setFormikPqrStrategicAlly(formik)}
            />
            <PqrRedirect
                data={pqr?.redirect}
                statusCode={statusCode}
                onChangeFormik={(formik) => setFormikPqrRedirect(formik)}
            />
            <PqrInFavorOf
                data={pqr?.inFavorOf}
                onChangeFormik={(formik) => setFormikPqrInFavorOf(formik)}
                typePqr={formikPqrData?.values?.type as string}
                isClousureStatus={isClousureStatus}
                label={formikPqrStatusManagement?.values?.label || ''}
            />
            <PqrFinalCausality
                data={pqr?.finalCausality}
                onChangeFormik={(formik) => setFormikPqrFinalCausality(formik)}
                isClousureStatus={isClousureStatus}
            />
            <PqrResponseMedium
                data={pqr?.responseMedium}
                onChangeFormik={(formik) => setFormikPqrResponseMedium(formik)}
                isClousureStatus={isClousureStatus}
            />
            <PqrClosing
                data={pqr?.closing}
                onChangeFormik={(formik) => setFormikPqrClosing(formik)}
                isClousureStatus={isClousureStatus}
                isSample={isSample}
                status={formikPqrStatusManagement?.values?.status as string}
                isSurvey={!!pqr?.survey}
                typePqr={formikPqrData?.values?.type as string}
            />
            <PqrDataSfc
                submotive1={
                    formikPqrInitialCausality?.values?.submotive1 as string
                }
                submotive2={
                    formikPqrInitialCausality?.values?.submotive2 as string
                }
                data={pqr?.dataSfc}
                onChangeFormik={(formik) => setFormikPqrDataSfc(formik)}
                receptionChannel={
                    formikPqrData?.values?.receptionChannel as string
                }
                country={pqr?.info?.country as string}
                location={pqr?.info?.location as string}
                hasReconsideration={pqr?.reconsideration?.hasReconsideration}
                status={formikPqrStatusManagement?.values?.status as string}
                half={formikPqrData?.values?.half as string}
                inFavorOf={formikPqrInFavorOf?.values?.inFavorOf as string}
                type={formikPqrData?.values?.type as string}
                isClousureStatus={isClousureStatus}
                responseDate={
                    formikPqrStatusManagement?.values?.responseDate as Date
                }
                customerFilingDatePqrStatus={
                    formikPqrStatusManagement?.values?.customerFilingDate
                }
                isCausalityFraud={isCausalityFraud}
            />
            <PqrAttachment
                onChangeData={setAttachments}
                data={pqr?.attachments}
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                {(!pqr || !pqr.id) && (
                    <LoadingButtonGeneral
                        disabled={loading}
                        title="Limpiar"
                        variant="outlined"
                        onClick={handleClean}
                    />
                )}
            </Grid>
            <Dialog
                title="Error de integración"
                open={isOpenErrorSFCModal}
                onClose={() => setIsOpenErrorSFCModal(false)}
            >
                <Grid
                    container
                    item
                    xs={12}
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Box
                        style={{
                            maxWidth: '500px',
                            textAlign: 'center',
                            padding: '16px',
                        }}
                    >
                        <Typography variant="h5">
                            Ocurrió un error en la integración
                            <>
                                <Typography
                                    variant="h6"
                                    style={{ marginTop: '16px' }}
                                >
                                    Resultado: {JSON.stringify(responseSmart)}
                                </Typography>
                            </>
                            {loading && <Loading />}
                        </Typography>
                    </Box>
                </Grid>
            </Dialog>
            {isOpen && (
                <Dialog
                    title={'Reglas Alertas'}
                    open={isOpen}
                    onClose={handleClose}
                    maxWidth="sm"
                >
                    <div dangerouslySetInnerHTML={{ __html: message || '' }} />
                </Dialog>
            )}
        </>
    );
};
